/**
 * Converts HTML to plain text with specific formatting rules:
 * - Preserves <br /> tags as line breaks
 * - Converts HTML paragraphs (<p>) to text with line breaks after each paragraph
 * - Converts HTML lists (ul/ol) to hyphenated lists (- item<br/>- item)
 * - Removes all other HTML tags while preserving content
 */
export const htmlToPlainTextWithHyphenatedLists = (htmlContent: string): string => {
  if (!htmlContent) return '';

  let result = htmlContent;

  // Handle paragraphs - add line break after each paragraph
  result = result.replace(/<p[^>]*>(.*?)<\/p>/gis, (_, content: string) => {
    const trimmedContent = content.trim();
    return trimmedContent ? `${trimmedContent}<br />` : '<br />';
  });

  const endListPlaceholder = '___END_LIST_PLACEHOLDER___';

  result = result.replace(/<(ul|ol)[^>]*>(.*?)<\/\1>/gis, (substring, __, content: string, startIndex: number) => {
    const listItems = content.match(/<li[^>]*>(.*?)<\/li>/gis);
    if (!listItems) return '';

    const hyphenatedItems = listItems.map((item) => {
      const itemContent = item.replace(/<li[^>]*>(.*?)<\/li>/gis, '$1').trim();

      return `- ${itemContent}`;
    });

    const isParagraphBefore = /<p[^>]*>(.*?)<\/p>$/gis.test(result.substring(0, startIndex));
    const isBrBefore = /<br[^>]*\/?>$/gis.test(result.substring(0, startIndex));

    if (!isParagraphBefore && !isBrBefore && startIndex > 0) {
      hyphenatedItems.unshift('');
    }

    return hyphenatedItems.join('<br />') + endListPlaceholder + '<br /><br />';
  });

  result = result.replace(
    new RegExp(`${endListPlaceholder}<br /><br /><br /><br />`, 'gi'),
    `${endListPlaceholder}<br /><br />`,
  );
  result = result.replace(new RegExp(endListPlaceholder, 'gi'), '');

  const brPlaceholder = '___BR_PLACEHOLDER___';
  result = result.replace(/<br[^>]*\/?>/gi, brPlaceholder);

  result = result.replace(/<[^>]+>/gi, '');

  result = result.replace(new RegExp(brPlaceholder, 'gi'), '<br />');

  result = result.replace(/(<br \/>\s*)+$/, '');

  return result.trim();
};
